import Centrifuge from 'centrifuge'
import store from '../store'
import { isOffer, normalizeMsg } from './order-book'

const CENTRIFUGE_URL = process.env.VUE_APP_CENTRIFUGE_URL || 'wss://trader.ucc.mn/connection/websocket'

export const centrifuge = new Centrifuge(
  CENTRIFUGE_URL,
  {
    onRefresh: function (ctx, cb) {
      console.debug('Token is refreshing')
      const token = store.getters['auth/accessToken']
      fetch(
        `${process.env.VUE_APP_API_BASE_URL || ''}/socket/refresh`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      ).then(resp => resp.json()).then(data => cb(data))
    },
  }
)

export const subscribe = (instance, chan, cb) => {
  return instance.subscribe(chan, msg => {
    const prefix = 'trade'
    const data = normalizeMsg(msg)

    data.trades.forEach(trade => cb(`${prefix}/pushTrade`, trade))

    if (Array.isArray(data.orders) && data.orders.length > 0) cb(`${prefix}/setOrders`, data.orders)
  })
};

export const subTradeAndOrder = (instance, symbol, cb) => {
  const currentOrderSub = subscribe(instance,
    `order:${symbol}`,
    (chan, data) => cb(chan, data))

  const currentTradeSub = subscribe(instance,
    `trade:${symbol}`,
    (chan, data) => cb(chan, data))

  currentOrderSub.on('subscribe', ctx => console.debug('order sub:', ctx))
  currentTradeSub.on('subscribe', ctx => console.debug('trade sub:', ctx))

  return { currentTradeSub, currentOrderSub }
}
